<div class="datastudio-container">
  <iframe
    [src]="datastudioUrl"
    frameborder="0"
    style="border:0"
    allowfullscreen
  ></iframe>
</div>
